import {
  SupplierCatalogConfig,
  currency,
  emptyColumn,
  fieldRowsToFields,
  text,
  WithRowId,
} from '../SupplierCatalog/supplierCatalogTypes'
import { TD_SYNNEX_FIELD_ROWS, TdSynnexSftpItemV2 } from './tdSynnexTypes'
import { tdSynnexItemToLineItem } from './tdSynnexLineItemMapping'

export const tdSynnexCatalogConfig: SupplierCatalogConfig<WithRowId<TdSynnexSftpItemV2>> = {
  supplier: 'TD Synnex',
  endpoint: '/tdsynnex/catalog',
  rowKey: row => row.rowId,
  partNumber: row => text(row.synnexPartNo),
  columns: [
    { label: 'Manufacturer', className: 'supplier-catalog-col-manufacturer', render: row => text(row.manufacturer) },
    { label: 'Mfr Part #', className: 'supplier-catalog-col-mfr-part', render: row => text(row.mfgPN) },
    { label: 'Description', className: 'supplier-catalog-col-description', render: row => text(row.shortDescription) },
    { label: 'IMPRES Price', className: 'supplier-catalog-col-impres-price', align: 'right', render: emptyColumn },
    { label: 'MSRP', className: 'supplier-catalog-col-msrp', align: 'right', render: row => currency(row.msrp) },
    { label: 'Product Category', className: 'supplier-catalog-col-product-category', render: emptyColumn },
    {
      label: 'Country of Origin',
      className: 'supplier-catalog-col-country',
      render: row => text(row.govClass?.coo ?? row.cooList),
    },
    { label: 'TAA', className: 'supplier-catalog-col-taa', render: row => text(row.taaCompliant) },
  ],
  drawerFields: fieldRowsToFields(TD_SYNNEX_FIELD_ROWS),
  toLineItem: (lineNumber, row) => tdSynnexItemToLineItem(lineNumber, row.mfgPN, row),
}
